import {ActionsModule} from "./actions-service.module.configuration";
import {ACTION_SERVICE_NAME} from "../utils/names/serviceNames";
import {ActionService} from "./service/ActionService";


ActionsModule.createNewModule()
    .service(ACTION_SERVICE_NAME, ActionService.instance);